module.exports = __webpack_public_path__ + "img/25_age-cohort.e0ff392f.jpg";